export interface GuaziNavItem {
  id: string;
  label: string;
}

export const guaziNavItems: GuaziNavItem[] = [
  { id: 'home', label: '首页' },
  { id: 'features', label: '功能特色' },
  { id: 'screenshots', label: '软件截图' },
  { id: 'advantages', label: '为什么选择' },
  { id: 'faq', label: '常见问题' },
];